import React from 'react';
import {CreatePOCToolStages} from './components/POCCMSPortal/POCToolCreator/POCToolCreatorNavigation/CreatePOCToolStages';
import POCToolSinglePage from './components/POCWebPortal/POCToolSinglePage/POCToolSinglePage';
import POCToolSummaries from './components/POCWebPortal/POCToolSummaries/POCToolsSummariesPage';
import POCtoolsCMSHome from './components/POCCMSPortal/POCtoolSummariesPage/POCtoolsCMSHome';
import LoginPage from './components/POCCMSPortal/login/LoginPage';
import MiniToolsSinglePage from './components/POCWebPortal/POCToolSinglePage/MiniToolsSinglePage';
import MiniToolContentSinglePage from './components/POCWebPortal/POCToolSinglePage/MiniToolContentSinglePage';

const AppRoutes = [
  {
    index: true,
    element: <CreatePOCToolStages />,
    path: '/NewPOCTool',
  },
  {
    index: true,
    element: <CreatePOCToolStages editMode={true} />,
    path: '/EditPOCTool/:id',
  },
  {
    index: true,
    element: <POCtoolsCMSHome />,
    path: '/POCtoolsCMSHome',
  },
  {
    index: true,
    element: <LoginPage />,
    path: '/Login',
  },
  {
    index: true,
    element: <POCToolSummaries />,
    path: '/',
  },
  {
    index: true,
    element: <POCToolSinglePage />,
    path: '/POCTool/:name/:id/',
  },
  {
    index: true,
    element: <MiniToolsSinglePage />,
    path: '/MiniTools/:name/:id/',
  },
  {
    index: true,
    element: <MiniToolContentSinglePage />,
    path: '/MiniTools/:miniToolname/:POCToolId/:minitoolId/',
  },
];

export default AppRoutes;
